import T3ChatAlternativePage from '@/components/Pages/T3ChatAlternativePage';

export default T3ChatAlternativePage;
